export const compareFirestoreDataWithLocal = (
    remoteTimestamp?: string,
    localTimestamp?: string,
) => {
    if (!remoteTimestamp) {
        return false;
    }

    if (!localTimestamp) {
        return true;
    }

    return new Date(remoteTimestamp) > new Date(localTimestamp);
};
